var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"mt-0",attrs:{"loading":_vm.isLoading,"disabled":_vm.isLoading,"label":_vm.value ? _vm.$t('active') : _vm.$t('orderStatus.ARCHIVED'),"color":"primary","dense":"","hide-details":""},on:{"change":_vm.save},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }